import PropTypes from 'prop-types';

export const DimensionPropType = PropTypes.shape({
  unit: PropTypes.string,
  length: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
});

/**
 * @typedef {('Inch'|'Inches'|'Centimeter'|'Centimeters'|'Unknown')} DimensionUnit
 */

/**
 * @typedef {object} DimensionsPropType
 * @property {DimensionUnit} unit
 * @property {string} length
 * @property {string} width
 * @property {string} height
 */
